import React from "react";

function PlusIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 15.2307V6.76915" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M6.76926 10.9999L15.2308 10.9999"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default PlusIcon;
